window.unlockLead = function(leadUuid) {
  $.ajax({
    url: `/qualification/leads/${leadUuid}/release`,
    method: 'post',
    dataType: 'json',
    async: true,
  }).done(function() {
    window.location.reload();
  });
}
